import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretBottom = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M11.5 5 8 8.5 4.5 5 3 6.5l5 5 5-5z"
	})
});
export default SvgCaretBottom;
